import { BasePage, BasePageProps } from '@xylabs/sdk-react'

interface Props extends BasePageProps {
  bgImg?: string
}

export const CustomBasePage: React.FC<Props> = ({ bgImg, ...props }) => {
  return <BasePage style={{ backgroundAttachment: 'fixed', backgroundImage: `url(${bgImg})`, backgroundSize: 'cover' }} {...props} />
}
